/*
 * @Author: cui
 * @Date: 2020-08-03
 * */

import { axiosResource } from "./axiosapi";

const API_HOST = "";
const SERVICE_NAME = "";

export const Resource = {
  /**
   * 首页
   */

  // 获取验证码
  getCheckCode: axiosResource(`${API_HOST}${SERVICE_NAME}/user/sendSms`),
  //图形验证码
  getSendSmsCaptcha: axiosResource(`${API_HOST}${SERVICE_NAME}/user/sendSmsCaptcha`),

  //登录
  getUserLogin: axiosResource(`${API_HOST}${SERVICE_NAME}/user/userLogin`),


  //获取轮播图
  getBanner: axiosResource(`${API_HOST}${SERVICE_NAME}/noXuanbei/pc/imageWebsite/queryImage`),



  //点赞
  likeClick: axiosResource(`${API_HOST}${SERVICE_NAME}/promotion/promotion/like`),
  //收藏
  collectClick: axiosResource(`${API_HOST}${SERVICE_NAME}/promotion/promotion/collect`),
  //转发
  // likeClick: axiosResource(`${API_HOST}${SERVICE_NAME}/promotion/like`),


  // 文章列表
  promotionList: axiosResource(`${API_HOST}${SERVICE_NAME}/promotion/promotion/pc/list`),
  // 文章列表分页
  promotionPageList: axiosResource('/promotion/promotion/pc/pageSearch'),
  // 文章详情
  promotionDetail: axiosResource(`${API_HOST}${SERVICE_NAME}/promotion/promotion/pc/detail`),
  // 文章阅读量
  promotionRead: axiosResource(`${API_HOST}${SERVICE_NAME}/promotion/promotion/read`),

};
